import React from 'react';
import AppShell from 'components/AppShell';
import Hero from './Home/Hero';
import UniversitiesCarousal from './Home/UniversitiesCarousal';
import WhyStuck from './Home/WhyStuck';
import EverythingYouNeed from './Home/EverythingYouNeed';
import WhyChooseUs from './Home/WhyChooseUs';
import Testimonials from './Home/Testimonials';
import CTABanner from './Home/CTABanner';
import Pricing from './Home/Pricing';
import FAQ from './Home/FAQ';

function HomePage() {
    return (
        <AppShell hideAnnouncement placeAtTop backgroundColor="#12111A">
            <Hero />
            {/* <UniversitiesCarousal /> */}
            <WhyStuck />
            <EverythingYouNeed />
            <WhyChooseUs />
            <Testimonials />
            <CTABanner />
            <Pricing />
            <FAQ />
        </AppShell>
    );
}

export default HomePage;
